import React, { useState, useEffect, useMemo } from 'react';
import { View, ScrollView, StyleSheet } from 'react-native';
import HeaderContainer from '../../components/shared/Header/Header.container';
import MobileHeader from '../../components/shared/Header/MobileHeader.component';
import ClockReport from '../../components/shared/ClockReport/Clock.container';
import ReportsListContainer from '../../components/shared/ClockReport/MobileReportsList/ReportsList.container';
import moment from 'moment';
import httpService from '../../services/http.service';
import { getUserData } from '../../store/selectors/login.selectors';
import { useSelector } from 'react-redux';
import { Privileges } from '../../constants/roleTypes.constant';
import Form101Card from './SubComponents/Form101Card';
import PaycheckCard from './SubComponents/PaycheckCard';
import AttendanceStatsCard from './SubComponents/AttendanceStatsCard';
import DailyHoursChart from './SubComponents/DailyHoursChart';
import WageSummaryCard from './SubComponents/WageSummaryCard';

const HomePageMobileWeb = ({
	navigation,
	isSummaryOnly,
	isPaycheckBlockShown,
	reportDateYear,
	reportContentData,
	report101warning,
	form101Id,
	form101Status,
	form101StatusCode,
	form101LastUpdate,
	monthlyAttendanceData,
	monthlyHoursData,
	weeklyData,
}: HomePageProps) => {
	const userData = useSelector(getUserData);
	const [show, setShow] = useState();
	const [standardHours, setStandardHours] = useState(0);
	const [aId, setAid] = useState(null);

	const clockReportOnly = useMemo(() => {
		const privileges = userData?.employeeRolePrivileges;
		return !(
			privileges?.includes(Privileges.ROLE_MY_PAYCHECKS_READ) ||
			privileges?.includes(Privileges.ROLE_MY_PAYCHECKS_WRITE)
		);
	}, [userData]);

	const getStandardHours = async () => {
		try {
			const res = await httpService.api<any>({
				type: 'getStandardByDate',
				params: { date: moment().local().format('YYYY-MM-DD') },
			});
			if (res) {
				setStandardHours(res);
			}
		} catch (e) {}
	};
	useEffect(() => {
		if (
			userData?.employeeRolePrivileges?.includes(
				Privileges.ROLE_LOG_WORK_READ,
			) ||
			userData?.employeeRolePrivileges?.includes(
				Privileges.ROLE_LOG_WORK_WRITE,
			)
		) {
			setAid(userData?.id);
			getStandardHours();
		}
	}, [userData]);

	if (clockReportOnly) {
		return (
			<>
				<HeaderContainer
					navigation={navigation}
					component={MobileHeader}
				/>
				<ClockReport report101warning={report101warning} />
				{show !== 'dashbourd' && (
					<ReportsListContainer
						aId={aId}
						standardHours={standardHours}
						setShow={setShow}
					/>
				)}
			</>
		);
	}
	if (isSummaryOnly) {
		return (
			<View style={styles.page}>
				<HeaderContainer
					navigation={navigation}
					component={MobileHeader}
				/>
				<ScrollView
					style={styles.scrollView}
					contentContainerStyle={styles.scrollContent}
					showsVerticalScrollIndicator={false}
				>
					<Form101Card
						form101Id={form101Id}
						isPaycheckBlockShown={isPaycheckBlockShown}
						report101warning={report101warning}
						form101Status={form101Status}
						form101StatusCode={form101StatusCode}
						form101LastUpdate={form101LastUpdate}
						reportDateYear={reportDateYear}
					/>
					<PaycheckCard reportDateYear={reportDateYear} />
					<WageSummaryCard
						reportDateYear={reportDateYear}
						reportContentData={reportContentData}
					/>
				</ScrollView>
			</View>
		);
	}

	return (
		<View style={styles.page}>
			<HeaderContainer navigation={navigation} component={MobileHeader} />
			<ScrollView
				style={styles.scrollView}
				contentContainerStyle={styles.scrollContent}
				showsVerticalScrollIndicator={false}
			>
				<ClockReport report101warning={report101warning} compact />
				<Form101Card
					form101Id={form101Id}
					isPaycheckBlockShown={isPaycheckBlockShown}
					report101warning={report101warning}
					form101Status={form101Status}
					form101StatusCode={form101StatusCode}
					form101LastUpdate={form101LastUpdate}
					reportDateYear={reportDateYear}
				/>
				<PaycheckCard reportDateYear={reportDateYear} />
				<AttendanceStatsCard monthlyAttendanceData={monthlyAttendanceData} />
				<DailyHoursChart weeklyData={weeklyData} />
				<WageSummaryCard
					reportDateYear={reportDateYear}
					reportContentData={reportContentData}
				/>
			</ScrollView>
		</View>
	);
};

const styles = StyleSheet.create({
	page: {
		flex: 1,
	},
	scrollView: {
		flex: 1,
	},
	scrollContent: {
		padding: 16,
		gap: 16,
	},
});

export default HomePageMobileWeb;
